import DeliveriesAdapter from './deliveries';

export default class extends DeliveriesAdapter {
  pathForType() {
    return 'devices';
  }
}
